import { memo, useState, useCallback } from 'react';

import {
  Accordion,
  AccordionDetails,
  AccordionSummary,
  alpha,
  Box,
  makeStyles,
  Paper,
  Typography,
} from '@material-ui/core';
import { UnfoldLess, UnfoldMore } from '@material-ui/icons';

import EventMessage from 'components/EventMessage';
import { MensagemInterface } from 'store/reducers/mensagens';

const useStyles = makeStyles(({ spacing, typography, palette }) => ({
  root: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    userSelect: 'none',
  },
  heading: {
    fontSize: typography.pxToRem(13),
    fontWeight: typography.fontWeightMedium as number,
    color: palette.primary.main,
    cursor: 'pointer',
    flex: 1,
  },
  accordion: {
    backgroundColor: 'transparent',

    '& .MuiAccordionSummary-root.Mui-expanded': {
      minHeight: 48,
      margin: 0,
    },
  },
  content: {
    '& .MuiAccordionSummary-content': {
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      margin: 0,
    },
  },
  details: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    paddingTop: 0,
  },
  contentMessage: {
    width: spacing(62.5),
    overflow: 'hidden',
    position: 'relative',
    padding: spacing(1),
    textAlign: 'center',
    color: palette.text.primary,
    border: '1px solid transparent',
    backgroundColor: alpha(palette.primary.main, 0.05),
    borderRadius: spacing(1),

    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
  },
}));

function EventGroupMessageComponent({
  eventos,
}: {
  eventos: MensagemInterface[];
}) {
  const classes = useStyles();
  const [expanded, setExpanded] = useState(false);

  const handleExpandChange = useCallback(() => {
    setExpanded(prev => !prev);
  }, []);

  return (
    <Accordion
      elevation={0}
      expanded={expanded}
      onChange={handleExpandChange}
      className={classes.accordion}
    >
      <AccordionSummary className={classes.content}>
        <Paper
          elevation={0}
          component="main"
          className={classes.contentMessage}
        >
          <Typography className={classes.heading}>
            {expanded
              ? 'Recolher eventos do atendimento'
              : `Ver ${eventos.length} eventos do atendimento`}
          </Typography>
          <Box style={{ position: 'absolute', right: 8, top: 8 }}>
            {expanded ? (
              <UnfoldLess color="primary" fontSize="small" />
            ) : (
              <UnfoldMore color="primary" fontSize="small" />
            )}
          </Box>
        </Paper>
      </AccordionSummary>
      <AccordionDetails className={classes.details}>
        <Box display="flex" flexDirection="column" gridGap={0.5}>
          {eventos.map(evento => (
            <EventMessage
              key={evento.id}
              fromMe
              mensagem={evento}
              onClick={() => setExpanded(false)}
            />
          ))}
        </Box>
      </AccordionDetails>
    </Accordion>
  );
}

export const EventGroupMessage = memo(EventGroupMessageComponent);
